// extracted by mini-css-extract-plugin
export default {"checkAndLabel":"checkbox_checkAndLabel__LVqj4","check":"checkbox_check__uz0Rq","label":"checkbox_label__yNq4c","error":"checkbox_error__sHLmC"};